import { Navigate, Route, Routes, useLocation } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import CreditsIndex from './CreditsIndex';
import CreditsPage from './CreditsPage';

interface Props {
    lang: MultiLang;
}

const CreditsIndexPage = (props: Props) => {
    const { lang } = props;
    const { search } = useLocation();
    const paramId = new URLSearchParams(search).get('id');
    if (paramId === null) {
        return <CreditsIndex lang={lang} />;
    }
    if (/^[1-9][0-9]*$/.test(paramId)) {
        return <CreditsPage lang={lang} id={parseInt(paramId, 10)} />;
    }
    return <PageNotFound lang={lang} />;
};

const Credits = (props: Props) => {
    const { lang } = props;
    const { search, hash } = useLocation();
    return (
        <Routes>
            <Route path="index.php" element={<CreditsIndexPage lang={lang} />} />
            <Route path="aboutus.php" element={<CreditsPage lang={lang} id={0} />} />
            <Route index element={<Navigate to={`/modules/credits/index.php${search}${hash}`} replace />} />
            <Route path="*" element={<PageNotFound lang={lang} />} />
        </Routes>
    );
};

export default Credits;
